<template>
  <div class="container">
    <div class="row">
      <div class="col-12 offset-lg-2 col-lg-8">
        <div class="alert alert-danger mt-3" role="alert" v-if="apiErrorI18nKey">
          <b>更新完了メッセージ</b>
          <!--<b>更新完了テスト<trans-text :i18nKey="apiErrorI18nKey"/></b>-->
        </div>
        <page-form :orderer="orderer" :user="user" @tryForm="tryForm"></page-form>
      </div>
    </div>
  </div>
</template>

<script>
  /* utils */
  import {dd,store,app} from 'systems/imports'
  import Orderer from 'processor/Orderer'
  /* ui */
  import PageForm from 'page/partials/MyPage/OrdererInfo/PageForm.vue'

  /** @name page_subPages_MyPage_OrdererInfo */
  export default {
    name:"",
    components: {
      PageForm,
    },
    data () {
      return {
        apiErrorI18nKey:null,
       user:{},
       orderer:{}
      }
    },
    created(){
    },
    methods:{
      tryForm(input){
        Orderer.save(input)
          .then((res) => {
            if (res.status === "ng") {
              //this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
              return
            }
            this.apiErrorI18nKey = "更新完了テスト"

          })
      }
    },
    mounted(){
      Orderer.get()
        .then((res) => {
          //dd("bbb",res);
          if (res.status === "ng") {
            this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
            return
          }
          //デフォルトにマージ
          this.orderer = Object.assign({
            family_name: "",
            given_name: "",
            address_1:"",
            address_2:"",
            city:"",
            prefecture:"",
            zip_code:"",
            phone_nunber:"",
            country_name:"",
            email: "",
            password: "",
          },res.data.orderer)



        })
    }
  }
</script>


<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// OrdererInfo.vue?793be130